/* =========================================================
   VINTAGE CHAMPIONS · Tarjetas de producto
   - Separa el nombre: "REAL MADRID 26/27" + etiqueta negra "VISITA"
     (todo lo que va después del año o temporada: LOCAL, VISITA, TERCERA, x COLDPLAY...)
   - Agrega la línea divisoria y la etiqueta de promo animada en la foto.
   ========================================================= */
(function () {
  /* Texto FINAL de la etiqueta roja (el que se queda). Déjalo en '' para ocultarla. */
  var BADGE_TEXT = 'EN TENDENCIA';
  /* Texto que aparece primero en la animación (círculo > ESTE TEXTO > círculo > BADGE_TEXT).
     Cámbialo por la promo vigente (ej. '3X2', 'BUEN FIN'). Déjalo en '' para ir directo al texto final. */
  var BADGE_INTRO = '5X3';

  var SEASON = /^\d[\d\/\-]*$/; // 26/27, 2007, 96, 97/99, 1998-99

  function splitTitle(link) {
    if (link.dataset.vcDone) return;
    link.dataset.vcDone = '1';
    var text = (link.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;
    var words = text.split(' ');
    var idx = -1;
    for (var i = 1; i < words.length; i++) {
      if (SEASON.test(words[i])) { idx = i; break; }
    }
    var main = text;
    var tag = '';
    if (idx > -1 && idx < words.length - 1) {
      main = words.slice(0, idx + 1).join(' ');
      tag = words.slice(idx + 1).join(' ');
    }
    link.textContent = '';
    var m = document.createElement('span');
    m.className = 'vc-title-main';
    m.textContent = main;
    link.appendChild(m);
    if (tag) {
      var g = document.createElement('span');
      g.className = 'vc-title-tag';
      g.textContent = tag;
      link.appendChild(g);
    }
    link.classList.add('vc-title-link');
  }

  /* ---------- Animación de la etiqueta ----------
     1. aparece un círculo  2. se abre en BADGE_INTRO  3. vuelve a círculo  4. se abre en BADGE_TEXT
     Se reproduce al entrar la tarjeta en pantalla y se reinicia al salir. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canAnimate = !reduceMotion && 'IntersectionObserver' in window && !!Element.prototype.animate;
  var EASE_POP = 'cubic-bezier(.34,1.56,.64,1)';
  var EASE = 'cubic-bezier(.65,0,.35,1)';
  var io = null;

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function fin(a) { return a.finished.catch(function () {}); }

  function naturalWidth(b, text) {
    var t = b.firstChild, w0 = b.style.width;
    t.textContent = text;
    b.style.width = 'auto';
    var w = b.getBoundingClientRect().width;
    b.style.width = w0;
    return w;
  }

  function reset(b) {
    b._vcRun = (b._vcRun || 0) + 1;
    b.getAnimations && b.getAnimations({ subtree: true }).forEach(function (a) { a.cancel(); });
    b.classList.remove('is-played');
    b.style.width = '';
    b.firstChild.style.opacity = '0';
    b.firstChild.textContent = BADGE_TEXT;
  }

  function play(b) {
    var run = (b._vcRun = (b._vcRun || 0) + 1);
    var t = b.firstChild;
    var alive = function () { return b._vcRun === run; };
    var h = b.getBoundingClientRect().height || 20;
    var circle = h + 'px';

    function grow(text) {
      var w = naturalWidth(b, text) + 'px';
      t.style.opacity = '0';
      b.style.width = w;
      return fin(b.animate([{ width: circle }, { width: w }], { duration: 480, easing: EASE }))
        .then(function () {
          if (!alive()) return;
          return fin(t.animate([{ opacity: 0, transform: 'translateY(35%)' },
                                { opacity: 1, transform: 'none' }],
                               { duration: 260, easing: 'ease-out' }))
            .then(function () { if (alive()) t.style.opacity = '1'; });
        });
    }
    function shrink() {
      var from = b.getBoundingClientRect().width + 'px';
      return fin(t.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-35%)' }],
                           { duration: 180, easing: 'ease-in' }))
        .then(function () {
          if (!alive()) return;
          t.style.opacity = '0';
          b.style.width = circle;
          return fin(b.animate([{ width: from }, { width: circle }], { duration: 420, easing: EASE }));
        });
    }

    b.classList.add('is-played');
    t.textContent = '';
    t.style.opacity = '0';
    b.style.width = circle;
    // 1. círculo que aparece
    fin(b.animate([{ transform: 'scale(0)', opacity: 0 }, { transform: 'scale(1)', opacity: 1 }],
                  { duration: 420, easing: EASE_POP }))
      .then(function () { return alive() && wait(220); })
      .then(function () {
        if (!alive()) return;
        if (!BADGE_INTRO) return 'skip';
        // 2. texto de promo (5X3)
        return grow(BADGE_INTRO).then(function () { return alive() && wait(1300); })
          // 3. de vuelta a círculo
          .then(function () { return alive() && shrink(); })
          .then(function () { return alive() && wait(160); });
      })
      .then(function () {
        if (!alive()) return;
        // 4. texto final (se queda)
        return grow(BADGE_TEXT);
      })
      .then(function () { if (alive()) b.style.width = ''; });
  }

  function watchBadge(b) {
    if (!canAnimate) { b.classList.add('is-static'); return; }
    b.classList.add('vc-badge-anim');
    reset(b);
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var badge = e.target.querySelector('.vc-card-badge');
          if (!badge) return;
          if (e.isIntersecting) { if (!badge.classList.contains('is-played')) play(badge); }
          else if (badge.classList.contains('is-played')) reset(badge);
        });
      }, { threshold: 0.35 });
    }
    io.observe(b.closest('.product-card__wrapper') || b);
  }

  function enhance(card) {
    if (card.dataset.vcCard) return;
    card.dataset.vcCard = '1';
    var link = card.querySelector('.product-card__title a');
    if (link) splitTitle(link);
    var title = card.querySelector('.product-card__title');
    if (title && !card.querySelector('.vc-divider')) {
      var d = document.createElement('div');
      d.className = 'vc-divider';
      d.setAttribute('aria-hidden', 'true');
      title.insertAdjacentElement('afterend', d);
    }
    if (BADGE_TEXT) {
      var box = card.querySelector('.product-card__image-container');
      if (box && !box.querySelector('.vc-card-badge')) {
        var b = document.createElement('span');
        b.className = 'vc-card-badge';
        b.setAttribute('aria-label', BADGE_TEXT);
        var t = document.createElement('span');
        t.className = 'vc-badge-text';
        t.textContent = BADGE_TEXT;
        b.appendChild(t);
        box.insertBefore(b, box.firstChild);
        watchBadge(b);
      }
    }
  }

  function run(root) {
    var cards = (root || document).querySelectorAll('.product-card__wrapper:not([data-vc-card])');
    for (var i = 0; i < cards.length; i++) enhance(cards[i]);
  }

  /* ¿Llegó alguna tarjeta nueva? (ignora cambios pequeños como el contador o el carrito) */
  function traeTarjetas(muts) {
    for (var i = 0; i < muts.length; i++) {
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j];
        if (n.nodeType !== 1) continue;
        if (n.classList.contains('product-card__wrapper') || n.querySelector('.product-card__wrapper:not([data-vc-card])')) return true;
      }
    }
    return false;
  }

  function start() {
    run(document);
    /* Tarjetas que llegan después (scroll infinito, filtros, recomendaciones, carrito) */
    var pending = false;
    new MutationObserver(function (muts) {
      if (pending || !traeTarjetas(muts)) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; run(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
